export default __webpack_public_path__ + "static/Element-a189b2d9e2fd6ce6af0bc02fd46c90b5.png";